import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { TMaterialStyles } from '../../../theme';
import React, { useCallback } from 'react';
import { ModalWrapper } from '../../Wrappers/ModalWrapper';
import { ButtonOutlined } from '../../Buttons/ButtonOutlined';
import { useTranslation } from 'react-i18next';
import TypographyWithShadow from '../../Typography/TypographyWithShadow';
import { useNavigate } from 'react-router';
import { ERoutes } from '../../../enums';
import { useGameStore } from '../../../stores';

interface IHippoFactModal {
  showHippoFactModal: boolean;
  setShowHippoFactModal: (value: boolean) => void;
}

export const HippoFactModal: React.FC<IHippoFactModal> = ({
  showHippoFactModal,
  setShowHippoFactModal,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const randomFact = useGameStore((state) => state.randomFact);

  const handleClose = useCallback(async () => {
    navigate(ERoutes.gameModes);
    setShowHippoFactModal(false);
  }, [navigate, setShowHippoFactModal]);

  return (
    <Modal
      open={showHippoFactModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalWrapper
        onClose={handleClose}
        isDark
        backgroundIllustrationName="HippoBlack"
      >
        <Box sx={materialStyles.container}>
          <TypographyWithShadow sx={materialStyles.title} shadowType="DARK">
            {t('game.facts_for_quizz')}
          </TypographyWithShadow>

          {randomFact && (
            <TypographyWithShadow sx={materialStyles.text} shadowType="DARK">
              {randomFact}
            </TypographyWithShadow>
          )}

          <Box sx={materialStyles.buttonWrapper}>
            <ButtonOutlined
              shadowType="DARK"
              sx={materialStyles.tryAgain}
              onClick={handleClose}
            >
              {t('common.close')}
            </ButtonOutlined>
          </Box>
        </Box>
      </ModalWrapper>
    </Modal>
  );
};

const materialStyles: TMaterialStyles = {
  container: {
    padding: '30px 30px',
  },
  buttonWrapper: {
    marginTop: 2,
    display: 'flex',
    justifyContent: 'center',
  },
  title: {
    fontFamily: 'Rubber Duck !important',
    fontSize: '30px',
    textAlign: 'center',
    marginBottom: '8px',
  },
  text: {
    fontSize: '16px',
    fontWeight: '700',
    textAlign: 'center',
    lineHeight: '20px',
  },
};
